import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "../styles/header.css";

function Header() {
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  const isPocetna =
    location.pathname === "/" || location.pathname === "/pocetna";

  useEffect(() => {
    if (!menuOpen) return;

    const zatvoriNaEscape = (e) => {
      if (e.key === "Escape") setMenuOpen(false);
    };

    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", zatvoriNaEscape);

    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", zatvoriNaEscape);
    };
  }, [menuOpen]);

  const handleNavClick = (sectionId) => {
    setMenuOpen(false);

    if (sectionId === "prijava") {
      navigate("/prijava");
      return;
    }

    if (location.pathname === "/" || location.pathname === "/pocetna") {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      navigate(`/${sectionId}`);
    }
  };

  const handleBackBtnClick = () => navigate("/pocetna");

  return (
    <header>
      {isPocetna && (
        <button
          className="menu-toggle"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-expanded={menuOpen}
          aria-controls="glavni-izbornik"
        >
          {menuOpen ? "Zatvori ✖" : "Izbornik ☰"}
        </button>
      )}

      {menuOpen && (
        <div
          className="nav-backdrop"
          onClick={() => setMenuOpen(false)}
          aria-hidden="true"
        />
      )}

      <h2 className="title-pocetna">
        <span className="title-puni">Odbojkaški klub Virtus</span>
        <span className="title-kratki">OK Virtus</span>
      </h2>

      <img
        src="/photos/logo/virtus_logo_10.png"
        alt="Virtus Logo"
        className="logo-header"
      ></img>

      {!isPocetna && (
        <button className="back-button" onClick={handleBackBtnClick}>
          Povratak ↩
        </button>
      )}

      <nav
        id="glavni-izbornik"
        className={`nav-menu ${menuOpen ? "active" : ""}`}
        aria-label="Glavni izbornik"
      >
        <ul>
          <li>
            <a
              href="#onama"
              onClick={(e) => {
                e.preventDefault();
                handleNavClick("onama");
              }}
            >
              O nama
            </a>
          </li>
          <li>
            <a
              href="#dvorane"
              onClick={(e) => {
                e.preventDefault();
                handleNavClick("dvorane");
              }}
            >
              Dvorane
            </a>
          </li>
          <li>
            <a
              href="#galerija"
              onClick={(e) => {
                e.preventDefault();
                handleNavClick("galerija");
              }}
            >
              Fotogalerija
            </a>
          </li>
          <li>
            <a
              href="#obavijesti"
              onClick={(e) => {
                e.preventDefault();
                handleNavClick("obavijesti");
              }}
            >
              Obavijesti
            </a>
          </li>
          <li>
            <a
              href="#kampovi"
              onClick={(e) => {
                e.preventDefault();
                handleNavClick("kampovi");
              }}
            >
              Volley&Fun
            </a>
          </li>
          <li>
            <a
              href="#treneri"
              onClick={(e) => {
                e.preventDefault();
                handleNavClick("treneri");
              }}
            >
              Treneri
            </a>
          </li>
          <li>
            <a
              href="#kontakt"
              onClick={(e) => {
                e.preventDefault();
                handleNavClick("kontakt");
              }}
            >
              Kontakt
            </a>
          </li>
          <li>
            <a
              href="https://som-sport.com/rsu-public/customer?company=virtus"
              className="gumb-prijava-nav"
              onClick={(e) => {
                e.preventDefault();

                const nastavi = window.confirm(
                  "Prijava se vrši putem sustava SOM Sport. Želite li otvoriti obrazac za prijavu?",
                );

                if (nastavi) {
                  window.open(
                    e.currentTarget.href,
                    "_blank",
                    "noopener,noreferrer",
                  );
                }
              }}
            >
              Upiši se u klub!
            </a>
          </li>
        </ul>
      </nav>

      <button
        className="signup"
        onClick={() => {
          setMenuOpen(false);
          const nastavi = window.confirm(
            "Prijava se vrši putem sustava SOM Sport. Želite li otvoriti obrazac za prijavu?",
          );

          if (nastavi) {
            window.open(
              "https://som-sport.com/rsu-public/customer?company=virtus",
              "_blank",
              "noopener,noreferrer",
            );
          }
        }}
      >
        <span>Upiši se</span>
      </button>
    </header>
  );
}

export default Header;
